module.exports = __webpack_public_path__ + "img/horizontal_7_6_2.16333bcb.png";